import React from "react";
import classes from "./Steppers.module.scss";
import { useTranslation } from "react-i18next";

export default function Steppers({
  stage = 1,
  steppes = null,
  showLabels = true,
  horizontal = false,
  checkAll = false,
}: {
  stage: number;
  steppes: Array<any> | null;
  showLabels?: boolean;
  horizontal?: boolean;
  checkAll?: boolean;
}) {
  const { t } = useTranslation();

  const getStep = (stage: number, steppes: Array<any>) => {
    let activeIndex = 0;
    return steppes.map((step, index) => {
      let finalClass = classes.Infos;

      if (stage === index + 1 || (checkAll && ++activeIndex < stage)) {
        finalClass += " " + classes.Active;
        finalClass += " " + classes.CheckAll;
      }
      return (
        <p className={finalClass} key={step + index}>
          <span className={classes.Dot}></span>
          {showLabels && <span className={classes.Info}>{t(step)}</span>}
        </p>
      );
    });
  };

  let _content = null;
  if (steppes) {
    let steppesClassName = classes.Stepper;
    if (horizontal) steppesClassName += " " + classes.Horizontal;
    _content = (
      <div className={steppesClassName}>{getStep(stage, steppes)}</div>
    );
  }
  return _content;
}
